/**
 * The inbox members forward bills to.
 *
 * Production SES receives `bills@app.healthsharetech.com` (ADR 003, rule
 * `bills-import`). Laravel builds the same local-part as `bills@` plus the
 * host of `APP_URL` (`RequestItemizedBillsJob`), but this repo does not record
 * a distinct staging recipient — staging `APP_URL` lives outside the tree —
 * so the production address is the default. A deployment that does have its
 * own inbox passes it in (`VITE_BILLS_FORWARDING_ADDRESS` on the web,
 * `BILLS_FORWARDING_ADDRESS` on the native build).
 */
export const DEFAULT_BILLS_FORWARDING_ADDRESS = 'bills@app.healthsharetech.com';

export function billsForwardingAddress(configured?: string | null): string {
  const value = configured?.trim();
  return value ? value : DEFAULT_BILLS_FORWARDING_ADDRESS;
}
